"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fluencyGoalCategories = void 0;
const zod_1 = require("zod");
const typing_utils_1 = require("../typing_utils");
exports.fluencyGoalCategories = [
    "listeningFluencyGoal",
    "readingFluencyGoal",
    "speakingFluencyGoal",
    "watchingTvFluencyGoal",
    "writingFluencyGoal",
];
const FluencyGoalCategorySchema = zod_1.z.union(typing_utils_1.mapArrayToLiteralTuple(exports.fluencyGoalCategories));
//# sourceMappingURL=fluency_goals_types.js.map